import axios from 'axios';
import { store } from './store';
import router from './router';
import { toast } from './toast';
import Toastification from './components/miscellaneous/Toastification.vue';
import _ from 'lodash';

// Set axios default header and Base Url
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//

axios.interceptors.request.use(async (config) => {
    store.commit('error/set', {});
    return config;
});

axios.interceptors.response.use(
    (response) => {
        // Status Messages
        if (response?.data?.status && response?.data?.status.type && response?.data?.status?.message) {
            let message = response.data.status.message;
            let type = response.data.status.type;

            toast[type === 'danger' ? 'error' : type]({
                component: Toastification,
                props: {
                    message: message,
                    type: type === 'danger' ? 'error' : type
                }
            });
        }

        // Meta Messages
        if (response.data?.meta?.messages?.length) {
            response.data.meta.messages.forEach((obj) => {
                Object.entries(obj).forEach((entry) => {
                    const [type, message] = entry;
                    toast[type === 'danger' ? 'error' : type]({
                        component: Toastification,
                        props: {
                            message: message,
                            type: type === 'danger' ? 'error' : type
                        }
                    });
                });
            });
        }

        // Redirect the User if Redirect exists
        if (response?.data?.meta?.redirect) {
            router.push(response.data.meta.redirect);
        }

        return Promise.resolve(response);
    },
    (error) => {
        // If action is unauthenticated or unauthorized redirect the User to the Login Page
        if (error?.response?.status === 401 || error?.response?.status === 403) {
            window.meta.authenticated = false;
            router.push('/login');
        }

        // If response Code is 503 Reload the Page
        if (error?.response?.status === 503) {
            location.reload();
        }

        // If response Code is 422 and Error Messages exist, store them in Error Store
        if (error?.response?.status === 422 && error?.response?.data?.errors) {
            if (error.response.config.componentId) {
                error.response.data.errors.componentId = error.response.config.componentId;
                store.commit('error/setByComponentId', error.response.data.errors);
            } else {
                store.commit('error/set', error.response.data.errors);
            }
        }

        return Promise.reject(error);
    }
);

export default {
    get(url, config) {
        return axios.get(url, config);
    },

    put(url, data, config) {
        return axios.put(url, data, config);
    },

    patch(url, data, config) {
        return axios.patch(url, data, config);
    },

    post(url, data, config) {
        return axios.post(url, data, config);
    },

    delete(url, config) {
        return axios.delete(url, config);
    }
};
